var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 214"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 234",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 235",
    cx: 30,
    cy: 30,
    r: 24,
    fill: "#F86557",
    stroke: "#122133",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBtnIcon);
export default __webpack_public_path__ + "static/media/camera-btn-icon.f75dabd7e4426fa375c4833b0cfe5a91.svg";
export { ForwardRef as ReactComponent };